import React from 'react';

import Image from 'next/image';
import Link from 'next/link';

import { Box, IconButton, Typography } from '@mui/material';

import { colors } from '@styles/theme';

import AstroIcon from '@public/logos/Icon-256.png';

type LogoVersion = 'mini' | 'full';

/**
 *
 * @param logoVersion - mini or full
 * @param href - pass the path where this logo link should redirect the user, if left empty it will default to '/'
 * @returns
 * if mini, returns a mini version of the logo without the text
 * if full, returns the full logo with icon and text
 */
const AstroLogoElement = ({
  logoVersion,
  href,
  dimensions,
}: {
  logoVersion: LogoVersion;
  href?: string;
  dimensions?: { height: number; width: number };
}) => {
  const logoHeight: number = dimensions && dimensions.height ? dimensions.height : 42;
  const logoWidth: number = dimensions && dimensions.width ? dimensions.width : 42;
  return (
    <>
      {logoVersion === 'full' && (
        <Link href={href ?? '/'} passHref style={{ textDecoration: 'none' }}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              // pl: 2,
              justifyContent: 'flex-start',
              alignItems: 'center',
              cursor: 'pointer',
              textDecoration: 'none',
            }}>
            <IconButton sx={{ p: 0, mr: 1 }}>
              <Image src={AstroIcon} height={42} width={42} alt={'Astro logo'} />
            </IconButton>
            <Typography
              variant='h3'
              noWrap
              component='p'
              sx={{
                background: colors.gradient.primary,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                textFillColor: 'transparent',
              }}>
              Astro
            </Typography>
          </Box>
        </Link>
      )}
      {logoVersion === 'mini' && (
        <Link href={href ?? '/'} passHref>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              cursor: 'pointer',
              textDecoration: 'none',
            }}
            component='a'>
            <IconButton sx={{ p: 0, mr: 1 }}>
              <Image src={AstroIcon} height={logoHeight} width={logoWidth} alt={'Astro logo'} />
            </IconButton>
          </Box>
        </Link>
      )}
    </>
  );
};

export default AstroLogoElement;
